import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, throwError } from 'rxjs';
import { GlobalErrorService } from '@services/global-error.service';

import {
  FeedbackResponse,
  UpdateFeedbackRequest,
} from './candidate-feedback.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CandidateFeedbackService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService
  ) {}

  getFeedbacks(candidateId: string): Observable<FeedbackResponse> {
    return this.http
      .get<FeedbackResponse>(`${this.baseUrl}/hiring/feedback/${candidateId}`)
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        })
      );
  }
  updateFeedback(feedbackData: UpdateFeedbackRequest): Observable<any> {
    const url = `${this.baseUrl}/hiring/feedback`;
    return this.http.put<any>(url, feedbackData).pipe(
      catchError((error) => {
        return this.errorHandler.logError(error);
      })
    );
  }

  getOpsReview(emailId: string): Observable<FeedbackResponse> {
    return this.http
      .get<FeedbackResponse>(`${this.baseUrl}/hiring/getFeedback/${emailId}`)
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        })
      );
  }
}
